import React from "react";
import FamilyPhoto from "./FamilyPhoto";

import slugIt from "../utils/slugIt";
import basePath from "../utils/basePath";

import ConfirmModal from "./ConfirmModal";
import DownloadModal from "./DownloadModal";
import ShareModal from "./ShareModal";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultLimit: 5,
      locale: "All destinations",
    };
    this.childRef = React.createRef();
  }
  allResults = [];
  familyTotals = {};
  categories = ["seclusion", "improvement", "distraction", "safety"];
  displayCategories = ["Seclusion", "Improvement", "Distraction", "Safety"];
  componentDidMount = () => {
    this.buildPieData();
  };

  handleInput = (event) => {
    console.log(event.target.value);
    this.setState({ [event.target.name]: event.target.value });
  };
  handleMoreResults = () => {
    this.refs[`res${this.state.resultLimit - 1}`].focus();
    this.setState({ resultLimit: this.state.resultLimit + 5 });
  };
  buildPieData = () => {
    let family = this.props.globalState.family;
    this.categories.map((category) => {
      this.familyTotals[category] = 0;
      return null;
    });
    family.map((member) => {
      this.categories.map((category) => {
        let choices = [member.accessories, member.gear, member.outfit, member.scenery];
        member.totals = {
          seclusion: 0,
          improvement: 0,
          distraction: 0,
          safety: 0,
          grand: 0,
        };
        choices.map((item) => {
          this.categories.map((category) => {
            member.totals[category] += item[category];
            member.totals.grand += item[category];
            return null;
          });
          return null;
        });

        this.familyTotals[category] += member.totals[category];
        return null;
      });
      return null;
    });
    let pieData = this.categories.map((category, index) => {
      return {
        name: this.displayCategories[index],
        keyName: category,
        y: this.familyTotals[category],
      };
    });

    return pieData;
  };

  pieHelper = (pieData, pieColors = ["#009A85", "#006293", "#718100", "#CE7107"]) => {
    //Rendering help for pie chart

    const highchartsOptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        height: 300,
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        margin: [0, 0, 0, 0],
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      colors: [
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, "#00C6B5"],
            [1, "#009A85"],
          ],
        },
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, "#257FC6"],
            [1, "#006293"],
          ],
        },
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, "#ADC602"],
            [1, "#718100"],
          ],
        },
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, "#EEA70D"],
            [1, "#CE7107"],
          ],
        },
      ],
      plotOptions: {
        pie: {
          series: {
            animation: false,
          },
          size: 250,
          dataLabels: {
            enabled: false,
          },
          borderWidth: 10,
        },
      },
      series: [
        {
          colorByPoint: true,
          data: pieData,
        },
      ],
    };
    let pieTotal = 0;
    let pieIntro = `A pie chart illustrating the percentage breakdown of your categories as follows:`;
    pieData.map((item) => {
      pieTotal += item.y;
      return null;
    });
    let srPieData = pieData.map((item, index) => {
      return (
        <div key={`pieDataPoint${index}`} className={`legend-key legend-key-${item.keyName}`}>
          <span className="perc" style={{ color: pieColors[index] }}>
            {Math.round((item.y * 100) / pieTotal)}%
          </span>
          <span className="title">{item.name}</span>
        </div>
      );
    });

    return (
      <figure>
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text-left">YOUR METHODS FOR GETTING THROUGH THE MADNESS:</h2>
          </div>
          <div className="col-xs-12 col-lg-5 p-0">
            <div aria-label={pieIntro} role="img" className="chart-wrapper">
              <div aria-hidden="true">
                <HighchartsReact highcharts={Highcharts} options={highchartsOptions} />
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-lg-7">
            <figcaption id="pie-chart">{srPieData}</figcaption>
          </div>
        </div>
      </figure>
    );
  };
  getFamilyBackground = (primary) => {
    // return this.props.globalState.avatarOptions.large.scenery.reduce((max, scene) =>
    //   max[primary] > scene[primary] ? max : scene
    // );
    return this.props.globalState.family[0].scenery;
  };
  getSortedTotals = () => {
    this.buildPieData();
    let totalsArray = this.categories.map((category) => {
      return {
        name: category,
        value: this.familyTotals[category],
      };
    });
    let sortedTotals = totalsArray.sort(function (a, b) {
      return b.value - a.value;
    });
    return sortedTotals;
  };
  filterLocations = () => {
    let sortedTotals = this.getSortedTotals(),
      primary = sortedTotals[0].name,
      secondary = sortedTotals[1].name,
      enabledLocations = this.props.globalState.locations.locations.filter((result) => {
        return result.enabled !== "false";
      });
    let tier1Results = enabledLocations.filter((result) => {
      return result.primary === primary && result.secondary === secondary;
    });
    let tier2Results = enabledLocations.filter((result) => {
      return result.primary === secondary && result.secondary === primary;
    });
    let tier3Results = enabledLocations.filter((result) => {
      return result.primary === primary && result.secondary !== secondary;
    });
    // let tier4Results = enabledLocations.filter(
    //   (result) => {
    //     return (
    //       (result.primary === secondary || result.secondary === primary) &&
    //       !(result.primary === secondary && result.secondary === primary)
    //     );
    //   }
    // );
    this.allResults = [...tier1Results, ...tier2Results, ...tier3Results];
    if (this.state.locale === "Domestic" || this.state.locale === "International") {
      this.allResults = this.allResults.filter((result) => {
        return result.locale === this.state.locale;
      });
    }
    return this.allResults;
  };

  downloadCanvas = (event) => {
    let dataURL = this.childRef.current.refs.canvas.toDataURL("image/png");
    event.target.href = dataURL;
    if (window.ga) {
      window.ga("send", "event", "Actions", "Click", "Download");
    }
  };
  resultHelper = (results) => {
    let resultHtml = results.map((res, index) => {
      if (this.state.resultLimit > index) {
        let ptNameSuffix = slugIt(res.name);
        let secondIcon = () => {
          if (res.secondary.length > 0) {
            return (
              <div>
                <img src={`${basePath}images/icon-mono-${res.secondary}.svg`} alt="" className="icon" />
              </div>
            );
          }
          return null;
        };
        return (
          <div className="result" key={`res${index}`} ref={`res${index}`} tabIndex="-1">
            <div className="tags">
              <div>
                <img src={`${basePath}images/icon-mono-${res.primary}.svg`} alt="" className="icon" />
              </div>
              {secondIcon()}
            </div>
            <h3>{res.name}</h3>
            <p>{res.location}</p>
            <a
              href={res.url}
              className="goto"
              rel="noopener noreferrer"
              target="_blank"
              //data-pt-name={`lnkResults_prop-${ptNameSuffix}`}
            >
              learn more
              <i className="far fa-angle-right" aria-hidden="true"></i>
            </a>
          </div>
        );
      }
      return null;
    });
    let adHTML = (
      <div className="orange-shadow" key={`resad`}>
        <div className="result result-ad" ref={`resad`} tabIndex="-1">
          <div className="row align-items-center flex-lg-row flex-column-reverse">
            <div className="col">
              <h3>Make the most of your travel with the Marriott Bonvoy Bold™ Credit Card</h3>
              <p>The Marriott Bonvoy Bold Card can help you say yes to creating unforgettable experiences with your family.</p>
              <a href="/travel-with-bold.php" className="goto">
                learn more
                <i className="far fa-angle-right" aria-hidden="true"></i>
              </a>
            </div>
            <div className="col p-5 p-lg-3 "></div>
          </div>
        </div>
      </div>
    );
    resultHtml.splice(2, 0, adHTML);
    return <div className="results">{resultHtml}</div>;
  };
  mailToHelper = (results) => {
    let resultCopy = results.map((res, index) => {
      if (index < 10) {
        return `${encodeURIComponent(res.name)}%0D%0A${encodeURIComponent(res.location)}%0D%0A${res.url}%0D%0A%0D%0A`;
      }
      return null;
    });
    let emailHref = `mailto:?subject=How%20you%202020&body=${resultCopy.join("")}`;
    return (
      <a href={emailHref} className="inline-link">
        Email this list
      </a>
    );
  };
  showMoreHelper = () => {
    if (this.state.resultLimit < this.allResults.length || this.state.resultLimit < 6) {
      return (
        <button type="button" className="btn btn-line" onClick={this.handleMoreResults}>
          SHOW MORE
        </button>
      );
    }
    return null;
  };
  render() {
    return (
      <div className="results">
        <section className="white" id="result-wrap">
          <div className="container">
            <div className="row">
              <div className="col">
                <h1>
                  <span className="leftblock">
                    SO&hellip; HOW
                    <br />
                    DID
                    <br />
                    YOU
                  </span>
                  <span className="rightblock">
                    <em>20</em>
                    <br />
                    <em>20</em>?
                  </span>
                </h1>
              </div>
            </div>
            <div className="row">
              <div className="col-md-7">
                <FamilyPhoto
                  globalState={this.props.globalState}
                  ref={this.childRef}
                  goTo={this.props.goTo}
                  backgroundImage={this.getFamilyBackground(this.getSortedTotals()[0].name).file}
                  clearAllRecords={this.props.clearAllRecords}
                />
              </div>
              <div className="col-md-5 text-center">
                {this.pieHelper(this.buildPieData())}
                <div className="download">
                  <DownloadModal modalId="downloadmodal" label="Download Avatar" buttonClass="btn btn-primary" onShow={this.downloadCanvas} />
                </div>
                <div className="actions">
                  <button type="button" className="inline-link" onClick={() => this.props.goTo("BuildAvatar", this.props.globalState.family[0].id)}>
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                    <br />
                    Edit
                  </button>

                  <ConfirmModal
                    modalId="clearmodal"
                    label="Restart"
                    buttonClass="inline-link"
                    iconClass="fa fa-undo"
                    question="Are you sure you want to clear all selections?"
                    title="Reset avatar?"
                    action={this.props.clearAllRecords}
                  />
                  <ShareModal modalId="sharemodal" label="Share this site" buttonClass="inline-link" iconClass="fa fa-share" />
                </div>
              </div>
            </div>
          </div>
          <div className="row"></div>
        </section>
        <a class="wrap-link" href="2020/gallery.php" data-nav-target="what-we-do" data-nav-direction="down">
          <section class="case-study-full light-link millgreen">
            <div class="container">
              <div class="row one-case">
                <div class="col-md-6 one-case-full">
                  <h2>See how the Millennium team 2020'd</h2>
                  <span class="text-link"> <strong>view gallery <i class="fa fa-angle"></i></strong></span>
                </div>
              </div>
            </div>
          </section>
        </a>
      </div>
    );
  }
}
export default Results;
